import { useDriverSchedules } from '@/api/useDriverSchedules'
import type { Dayjs } from 'dayjs'
import { useMemo } from 'react'
import { useSchedulePageFilters } from '../Filters/SchedulePageFilterContext'
import { createScheduleItemDatabase, useScheduleDataStore } from './scheduleItemStore'
import { type RowItem, useFilteredItems } from './useFilteredItems'

export const useInitializeItems = <T extends RowItem>(
  data: T[] = [],
  dateRangeOverride?: { start: Dayjs; end: Dayjs }
) => {
  const { useSchedules } = useDriverSchedules()
  const { dateRange } = useSchedulePageFilters()

  const { data: schedules, isLoading } = useSchedules(
    dateRangeOverride ? dateRangeOverride : { start: dateRange.startDate, end: dateRange.endDate }
  )
  const { data: itemsWithConflicts, tree } = useScheduleDataStore(schedules ?? [])
  const { filteredRows, filteredItems } = useFilteredItems<T>(data ?? [], itemsWithConflicts)
  const search = useMemo(() => {
    const result = createScheduleItemDatabase(filteredItems)
    return result.search
  }, [filteredItems])

  return {
    items: filteredItems,
    rows: filteredRows,
    search,
    isLoading,
    getOverlappingSchedules: tree.getOverlappingSchedules,
  }
}
